/* Tuckly product landing (sections/tk-landing.liquid). Vanilla, no dependencies.
   - Scroll reveals: adds .tkl--anim only when motion is welcome; content is visible without JS.
   - Buy buttons: click the main product form's own add-to-cart button (Horizon keeps the cart
     drawer, fly-to-cart and errors); products with options scroll back to the buy box.
   - 3D: loads Shopify's model-viewer when the stage nears the viewport (or on tap), then swaps the
     poster for the live viewer. Re-runs Shopify XR setup so the AR button appears on capable phones.
   - Rails: prev/next buttons for horizontal scene rails. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('[data-tkl-reveal]');
    if (reduce || !('IntersectionObserver' in window) || !els.length) return;
    root.classList.add('tkl--anim');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach(function (el) {
      // anything already above the fold on load shows at once
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  function buy(root) {
    var pid = root.getAttribute('data-product-id');
    root.querySelectorAll('[data-tkl-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = document.querySelector('product-form-component[data-product-id="' + pid + '"]');
        var target = form && form.querySelector('[ref="addToCartButton"]');
        var single = btn.getAttribute('data-single') === 'true';
        if (single && target && !target.disabled) {
          target.dataset.puppet = 'true';
          target.click();
          btn.classList.add('is-added');
          var label = btn.querySelector('.tkl-btn__label');
          var was = label ? label.textContent : '';
          if (label) label.textContent = 'Added to cart';
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (label) label.textContent = was;
            target.dataset.puppet = 'false';
          }, 2200);
          return;
        }
        var box = document.querySelector('.product-information .product-details') || form;
        if (box) box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function setupXR() {
    if (window.ShopifyXR && window.ShopifyXR.setupXRElements) {
      try {
        window.ShopifyXR.setupXRElements();
      } catch (e) {}
    } else {
      document.addEventListener(
        'shopify_xr_initialized',
        function () {
          if (window.ShopifyXR) window.ShopifyXR.setupXRElements();
        },
        { once: true }
      );
    }
  }

  function model(root) {
    var stage = root.querySelector('[data-tkl-model]');
    if (!stage) return;
    var started = false;
    function start() {
      if (started) return;
      started = true;
      stage.classList.add('is-loading');
      var tpl = stage.querySelector('template[data-tkl-model-tpl]');
      if (!tpl) return;
      stage.appendChild(tpl.content.cloneNode(true));
      var mv = stage.querySelector('model-viewer');
      if (!mv) return;
      function live() {
        stage.classList.remove('is-loading');
        stage.classList.add('is-live');
      }
      mv.addEventListener('load', live, { once: true });
      var go = function () {
        // model-viewer upgrades on its own once the element is defined
        if (window.customElements && customElements.get('model-viewer')) {
          if (mv.loaded) live();
        }
      };
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: go }]);
      }
      setTimeout(function () {
        if (!stage.classList.contains('is-live') && mv.loaded) live();
      }, 4000);
    }
    var btn = stage.querySelector('[data-tkl-model-load]');
    if (btn) btn.addEventListener('click', start);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            io.disconnect();
            start();
          }
        },
        { rootMargin: '300px 0px' }
      );
      io.observe(stage);
    }
    setupXR();
  }

  function rails(root) {
    root.querySelectorAll('[data-tkl-rail-root]').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-tkl-rail]');
      var prev = wrap.querySelector('[data-tkl-rail-prev]');
      var next = wrap.querySelector('[data-tkl-rail-next]');
      if (!rail || !prev || !next) return;
      function step() {
        var card = rail.firstElementChild;
        return card ? card.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
      }
      function sync() {
        prev.disabled = rail.scrollLeft < 8;
        next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      }
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
      });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  function videos(root) {
    var vids = root.querySelectorAll('video[data-tkl-autoplay]');
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && v.offsetParent !== null) {
            v.muted = true;
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.2 }
    );
    vids.forEach(function (v) {
      io.observe(v);
    });
  }

  function init() {
    document.querySelectorAll('[data-tkl]').forEach(function (root) {
      if (root.hasAttribute('data-tkl-ready')) return;
      root.setAttribute('data-tkl-ready', '');
      reveal(root);
      buy(root);
      model(root);
      rails(root);
      videos(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
